





































import { Component } from 'vue-property-decorator';
import CurrencyMixin from '@/components/helpers/currency-mixin';
import query from '@/components/query/query-constructor';

@Component
export default class CurrencyPicker extends CurrencyMixin {
  mounted() {
    const routeParams = query.decode(this.$route.params.data as string);
    const { currency } = routeParams;
    this.$store.commit('dashboardQueryTemporary',{
      name: 'currency',
      value: currency || this.$store.state.user.currencyId
    })


    this.$store.commit('applyDashboardQuery');
  }

  onChange(value) {
    this.$store.commit('dashboardQueryTemporary',{
      name: 'currency',
      value: value
    })
  }

  get icon() {
    const name = (this.$store.state.dashboard.queryTemporary.currency || 'usd').toLowerCase();
    return this.currenciesLowerCase[name];
  }
}
